import React from "react";
import type {ConstructionTableRowProps, TableData} from "./ConstructionTableProps";
import ConstructionTableRowCell from "./ConstructionTableRowCell";
import {hasId, hasParentId, isGuiValueDto, hasExtraInfo} from "./constructionTableRowHelpers";
import type GuiValueDto from "../../../../dto/construction/GuiValueDto";
import type DeviceDto from "../../../../dto/construction/parts/DeviceDto";

const ConstructionTableRow: React.FunctionComponent<ConstructionTableRowProps> = ({
  constructionId,
  constructionElementsName,
  constructionPartItem,
  isAccepted,
  renderEmpty = false,
}) => {
  return (
    <tr>
      {Object.keys(constructionPartItem).map((key, j) => {
        const rawValue = constructionPartItem[key as keyof TableData];
        const guiValue =
          renderEmpty && isGuiValueDto(rawValue) ? {...(rawValue as GuiValueDto<unknown>), value: ""} : rawValue;
        return (
          <ConstructionTableRowCell
            key={j}
            header={key}
            constructionElementsName={constructionElementsName}
            constructionElementProperty={key}
            guiValue={guiValue}
            constructionElementEntityId={hasId(constructionPartItem) ? constructionPartItem.id : ""}
            constructionId={constructionId}
            constructionElementParentId={hasParentId(constructionPartItem) ? constructionPartItem.parentId : ""}
            isAccepted={isAccepted}
            renderEmpty={renderEmpty}
            extraInfo={hasExtraInfo(constructionElementsName, key) ? {family: (constructionPartItem as DeviceDto).family.value} : undefined}
          />
        );
      })}
    </tr>
  );
};

export default ConstructionTableRow;
